export default __webpack_public_path__ + "static/media/transition2.f522dace.mp3";